/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';

import AppTable from 'components/appTable';
import SearchBox from 'components/form/searchBox';
import Gap from 'components/gap';
import PanelBoxLayout from 'components/layout/panelBox';
import { useActions } from 'common/hooks/useActions';

import * as S from './styles';
import * as T from 'common/types';
import PaginationApp from 'components/pagination';
import { useParams } from 'react-router';
import { ReactSVG } from 'react-svg';

interface IProps {
  data: T.Pages.SurveyResult;
  loading: boolean;
}

export default function SurveyShowTable({ data, loading }: IProps) {
  const params = useParams();

  const { surveysResultRequestAction } = useActions();
  const [meta, setMeta] = useState({
    page: 1,
    page_size: 10,
    search: '',
    type: '',
    id: params.id
  });

  const fetchData = () => {
    surveysResultRequestAction(meta);
  };

  useEffect(() => {
    fetchData();
  }, [meta]);

  const handleChangePage = (page: number) => {
    setMeta({ ...meta, page });
  };

  const handleChangePageSize = (page_size: number) => {
    setMeta({ ...meta, page_size });
  };

  console.log('data', data);

  return (
    <S.Content>
      <PanelBoxLayout>
        {/* <S.Head>
          <SearchBox
            onChange={(e) => setMeta({ ...meta, search: e })}
            placeholder="Search"
            inputStyle={{ height: 36, borderRadius: 10, fontSize: 12 }}
            style={{ width: 500 }}
          />
        </S.Head> */}
        <Gap size="20px" />
        {/* <AppTable
          headers={[
            { id: 1, title: 'Employee ID', dir: 'left' },
            { id: 2, title: 'User', dir: 'left' },
            ...data?.questions?.map((item: any, index: number) => ({
              id: index,
              title: item.title,
              dir: 'left' as any
            }))
          ]}
          loading={loading}
          data={data.answers}
          altanfeethiFields={{
            id: (item: T.Pages.SurveyResultAnswer) => <S.Div className="text-left">{item?.userId}</S.Div>,

            Username: (item: T.Pages.SurveyResultAnswer) => <S.Div className="text-left ">{item?.name}</S.Div>
            // ...data?.answers?.map((item: any, index: number) => (item: T.Pages.SurveyResultAnswer) => (
            //   <S.Div className="text-left ">{item?.name}</S.Div>
            // ))
            // Question: (item: T.Pages.SurveyResultAnswer) => <S.Div className="text-left ">{item?.name}</S.Div>,
            // Question2: (item: T.Pages.SurveyResultAnswer) => <S.Div className="text-left ">{item?.name}</S.Div>,
            // Question3: (item: T.Pages.SurveyResultAnswer) => <S.Div className="text-left ">{item?.name}</S.Div>
          }}
        /> */}
        <S.TableCon>
          {loading ? (
            <S.TableLoading>
              <img src="/logos/logo-mini.png" width={70} height={70} />
              <S.Loader>
                <ReactSVG
                  src="/loader.svg"
                  wrapper="span"
                  beforeInjection={(svg) => {
                    svg.setAttribute('width', `70px`);
                    svg.setAttribute('height', `70px`);
                  }}
                />
              </S.Loader>
            </S.TableLoading>
          ) : (
            <></>
          )}
          <S.Table>
            <S.Thead>
              <S.Tr>
                <S.Th>
                  <S.HeaderTh
                    style={{
                      justifyContent: 'left'
                    }}
                  >
                    Employee ID
                  </S.HeaderTh>
                </S.Th>
                <S.Th>
                  <S.HeaderTh
                    style={{
                      justifyContent: 'left'
                    }}
                  >
                    User
                  </S.HeaderTh>
                </S.Th>
                {data?.questions?.length > 0 &&
                  data?.questions
                    ?.sort((q1, q2) => q1.id - q2.id)
                    .map((item: T.Pages.SurveyResultQuestion, index) => {
                      return (
                        <S.Th key={index}>
                          <S.HeaderTh
                            style={{
                              justifyContent: 'left'
                            }}
                          >
                            {item.title}
                          </S.HeaderTh>
                        </S.Th>
                      );
                    })}
              </S.Tr>
            </S.Thead>
            <S.Tbody>
              {data?.answers?.length > 0 &&
                data?.answers?.map((item: T.Pages.SurveyResultAnswer, index) => {
                  return (
                    <S.Tr key={index}>
                      <S.Td
                        style={{
                          textAlign: 'left'
                        }}
                      >
                        {item?.userId}
                      </S.Td>
                      <S.Td
                        style={{
                          textAlign: 'left'
                        }}
                      >
                        {item?.name}
                      </S.Td>
                      {item?.answers
                        ?.sort((a1, a2) => a1?.questionId - a2?.questionId)
                        .map((answer: { answer: string; questionId: number }) => (
                          <S.Td
                            key={answer.questionId}
                            style={{
                              textAlign: 'left'
                            }}
                          >
                            {answer.answer}
                          </S.Td>
                        ))}
                    </S.Tr>
                  );
                })}
            </S.Tbody>
          </S.Table>
        </S.TableCon>
      </PanelBoxLayout>
      {/* {data.totalPages ? (
        <PaginationApp
          page={meta.page}
          count={meta.page_size * data.totalPages}
          handleChangePage={(page: number) => handleChangePage(page)}
          key={data.totalPages}
          pageSize={meta.page_size}
          handleChangeTake={handleChangePageSize}
        />
      ) : (
        <></>
      )} */}
    </S.Content>
  );
}
